module.exports = __webpack_public_path__ + "img/logo_fox16.62611f2c.png";